import { z } from 'zod/v4';
// Re-export platform role from operator schema for convenience
export { PlatformRoleSchema } from '../operators/operator.schema.js';
export const UserRoleSchema = z.enum([
    'attorney',
    'paralegal',
    'assistant',
    'admin',
    'other',
]);
export const UserStatusSchema = z.enum([
    'pending',
    'approved',
    'suspended',
    'inactive',
]);
export const UserSchema = z.object({
    id: z.string().uuid(),
    auth0Id: z.string(),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string().optional(),
    role: UserRoleSchema,
    status: UserStatusSchema,
    company: z.string().optional(),
    barNumber: z.string().optional(),
    stateOfRecord: z.string().optional(),
    customerNumber: z.string().optional(),
    address: z.object({
        street: z.string(),
        city: z.string(),
        state: z.string(),
        zip: z.string(),
    }).optional(),
    preferences: z.object({
        emailNotifications: z.boolean().default(true),
        smsNotifications: z.boolean().default(false),
    }).optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    approvedAt: z.string().datetime().optional(),
    lastLoginAt: z.string().datetime().optional(),
});
export const CreateUserSchema = UserSchema.omit({
    id: true,
    customerNumber: true,
    createdAt: true,
    updatedAt: true,
    approvedAt: true,
    lastLoginAt: true,
});
export const UpdateUserSchema = UserSchema.partial().omit({
    id: true,
    auth0Id: true,
    createdAt: true,
});
